import React from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

const AccountFormGeneral = ({ accounts, errors, handleValueChange, isSubmitted, t, values }) => {
  return (
    <Form.Section title={t('accounts.form.general')}>
      <div className="row align-items-center">
        <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
          <Form.FieldInput
            error={(isSubmitted && errors.key) || {}}
            name={'key'}
            label={t('accounts.fields.key')}
            handleChange={handleValueChange}
            t={t}
            value={values.key}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
          <Form.FieldInput
            error={(isSubmitted && errors.name) || {}}
            name={'name'}
            label={t('accounts.fields.name')}
            handleChange={handleValueChange}
            t={t}
            value={values.name}
          />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
          <Form.Checkbox
            name="active"
            className="icheckbox_flat-blue"
            onChange={handleValueChange}
            checked={values.active}
            label={t('common.active', { context: 'female' })}
          />
        </div>
        {/* <div className="col-sm-6 col-md-4 col-lg-3">
          <Form.FieldSelect
            error={(isSubmitted && errors._parent) || {}}
            name={"_parent"}
            label={t("accounts.fields._parent")}
            handleChange={handleValueChange}
            t={t}
            value={values._parent}
          >
            {accounts.map(account => (
              <option key={account.id} value={account.id}>
                {account.key} - {account.name}
              </option>
            ))}
          </Form.FieldSelect>
        </div> */}
        <div className="col-12">
          <Form.FieldTextArea
            error={(isSubmitted && errors.description) || {}}
            name={'description'}
            label={t('accounts.fields.description')}
            handleChange={handleValueChange}
            t={t}
            value={values.description}
          />
        </div>
      </div>
    </Form.Section>
  );
};

export default translate()(AccountFormGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/form/sections/AccountFormGeneral.js